import { ReactNode } from "react";
import { Box, Paper, Stack, Typography } from "@mui/material";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { CreateTeamFormData } from "../types";
import { LabelValueRow as Row } from "../../components/LabelValueRow";
import {
  MONTHLY_PRO_CREDITS,
  ANNUAL_PRO_CREDITS,
} from "../../../constants/proCredits";

const Note = ({ icon, children }: { icon: ReactNode; children: ReactNode }) => (
  <Stack direction="row" spacing={1.25} alignItems="flex-start">
    <Box sx={{ color: "#6B44D6", display: "flex", mt: "1px" }}>{icon}</Box>
    <Typography variant="body2" sx={{ color: "#333" }}>
      {children}
    </Typography>
  </Stack>
);

/** After payment: what the team has, and how sharing works, before inviting people. */
export const ReadyStep = ({ data }: { data: CreateTeamFormData }) => {
  const yearly = data.interval === "yearly";
  const credits =
    data.seats * (yearly ? ANNUAL_PRO_CREDITS : MONTHLY_PRO_CREDITS);
  const name = data.firmName.trim();
  return (
    <Stack spacing={2.5} data-testid="create-team-ready">
      <Typography variant="body2" color="text.secondary">
        You're the admin. Invite the people you work with, and each of them gets
        an email to join.
      </Typography>
      <Paper
        elevation={0}
        sx={{ p: "12px 16px", borderRadius: "14px", bgcolor: "#F7F7F9" }}
      >
        <Stack spacing={1}>
          <Row label="Seats" value={`${data.seats}, including yours`} />
          <Row
            label="Team credits"
            value={`${credits.toLocaleString("en-US")} ${yearly ? "upfront" : "per month"}`}
          />
        </Stack>
      </Paper>
      <Stack spacing={1.5}>
        <Note icon={<LockOutlinedIcon sx={{ fontSize: 18 }} />}>
          Your Personal work stays private. What you make in {name} is private
          until you share it.
        </Note>
        <Note icon={<GroupsOutlinedIcon sx={{ fontSize: 18 }} />}>
          Share boards, projects and concepts with the whole team or with one
          teammate.
        </Note>
      </Stack>
    </Stack>
  );
};
